export enum RecorderState {
  Recording,
  Stopped
}
